import { InviteMemberDocument, InviteMemberAPIPathGenerator, APIQueryParamFragments, InviteUserUpdate, APIResponse } from "server-model";
import { InviteMemberConnector, OrganisationConnector, OrganisationMemberConnector } from "../data-connectors";
import { AppServerConnector } from "./app-server.connector";

export class AppServerInviteMemberConnector extends AppServerConnector implements InviteMemberConnector {
    async getInvite(token: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                InviteMemberAPIPathGenerator.get(token),
                {
                    headers: {
                        'x-skip-auth-validation': 'true'
                    }
                }
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Invite not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async createInvite(organisationId: string, inviteMemberDocument: InviteMemberDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                InviteMemberAPIPathGenerator.create(organisationId),
                { inviteMemberDocument: this.toPlain(inviteMemberDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to create invite")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async resendInvite(email: string, organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                InviteMemberAPIPathGenerator.resend(organisationId),
                { ...this.getHeaders(), params: { [APIQueryParamFragments.EMAIL]: email } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to resend invite")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deleteInvite(email: string, organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.delete(
                InviteMemberAPIPathGenerator.delete(organisationId),
                { ...this.getHeaders(), params: { [APIQueryParamFragments.EMAIL]: email } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to delete invite")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updateUser(userId: string, inviteUserUpdate: InviteUserUpdate): Promise<APIResponse> {
        try {
            const response = await this.axios.put(
                InviteMemberAPIPathGenerator.updateUser(userId),
                { inviteUserUpdate: this.toPlain(inviteUserUpdate) },
                {
                    headers: {
                        'x-skip-auth-validation': 'true'
                    }
                }
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to delete invite")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}